/**
 * OnboardingProgressBar Component
 * Shows the current step and progress in the onboarding flow
 */

import { useLocation, useParams } from 'react-router-dom';
import styles from './OnboardingProgressBar.module.css';

const OnboardingProgressBar = () => {
    const location = useLocation();
    const { token } = useParams();

    // Define the steps in order
    const steps = [
        { id: 'welcome', label: 'Welcome', path: `/client-onboarding/${token}` },
        { id: 'terms', label: 'Terms & Conditions', path: `/client-onboarding/${token}/terms` },
        { id: 'account-type', label: 'Account Type', path: `/client-onboarding/${token}/account-type` },
        { id: 'client-info', label: 'Client Info', path: `/client-onboarding/${token}/business-info` },
        { id: 'contacts', label: 'Contacts', path: `/client-onboarding/${token}/billing-reporting` },
        { id: 'reporting', label: 'Reporting Requirements', path: `/client-onboarding/${token}/reporting-requirements` },
        { id: 'qc-disposal', label: 'QC & Disposal', path: `/client-onboarding/${token}/qc-disposal` },
        { id: 'review', label: 'Review', path: `/client-onboarding/${token}/review` }
    ];

    // Determine current step index based on path
    const getCurrentStepIndex = () => {
        const path = location.pathname;
        if (path.endsWith('/terms')) return 1;
        if (path.endsWith('/account-type')) return 2;
        if (path.endsWith('/business-info')) return 3;
        if (path.endsWith('/billing-reporting')) return 4;
        if (path.endsWith('/reporting-requirements')) return 5;
        if (path.endsWith('/qc-disposal')) return 6;
        if (path.endsWith('/review')) return 7;
        return 0; // welcome
    };

    const currentStepIndex = getCurrentStepIndex();

    return (
        <div className={styles.progressContainer}>
            <div className={styles.stepsWrapper}>
                {steps.map((step, index) => {
                    const isCompleted = index < currentStepIndex;
                    const isCurrent = index === currentStepIndex;
                    const isUpcoming = index > currentStepIndex;

                    return (
                        <div key={step.id} className={styles.stepItem}>
                            <div className={styles.stepIndicator}>
                                <div
                                    className={`${styles.stepCircle} ${
                                        isCompleted ? styles.completed :
                                        isCurrent ? styles.current :
                                        styles.upcoming
                                    }`}
                                >
                                    {isCompleted ? (
                                        <span className={styles.checkmark}>✓</span>
                                    ) : (
                                        <span className={styles.stepNumber}>{index + 1}</span>
                                    )}
                                </div>
                                {index < steps.length - 1 && (
                                    <div
                                        className={`${styles.stepLine} ${
                                            isCompleted ? styles.completedLine : styles.upcomingLine
                                        }`}
                                    />
                                )}
                            </div>
                            <div className={styles.stepLabel}>
                                <span
                                    className={`${styles.stepText} ${
                                        isCurrent ? styles.currentText : ''
                                    }`}
                                >
                                    {step.label}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OnboardingProgressBar;
